import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find-index.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import { defineComponent as _defineComponent } from 'vue';
import UpSellProduct from './UpSellProduct.vue';
import ProgressBar from './ProgressBar.vue';
import NativeCarousel from '~/components/Molecules/NativeCarousel.vue';
import { useCart } from '~/composables/useCart';
import { useUpsellProducts } from '~/composables/attraqt/useAttraqtIntegration';
import { useGetTranslations } from '~/composables/useGetTranslations';
import { useCartPreview } from '~/composables/useCheckout/modules/useCartPreview';
import { useCustomerGroup } from '~/composables/useCustomerGroup';
import { useShippingMethods } from '~/composables/useShippingMethods';
import { useLocalization } from '~/composables/_next/useLocalization';
export default /*#__PURE__*/_defineComponent({
  __name: 'UpSellProductsCarousel',
  setup: function setup(__props) {
    var _useCart = useCart(),
      updateShippingAddress = _useCart.updateShippingAddress;
    var _useCustomerGroup = useCustomerGroup(),
      isCustomerGroupWithoutVat = _useCustomerGroup.isCustomerGroupWithoutVat;
    var _useUiState = useUiState(),
      isCartSidebarOpen = _useUiState.isCartSidebarOpen;
    var _useShippingMethods = useShippingMethods(),
      loadShippingMethods = _useShippingMethods.loadShippingMethods,
      getShippingFreeAboveRate = _useShippingMethods.getShippingFreeAboveRate;
    var _useCart2 = useCart(),
      cart = _useCart2.cart,
      countItemsWithoutGift = _useCart2.countItemsWithoutGift;
    var context = useNuxt2App();
    var _useLocalization = useLocalization(),
      country = _useLocalization.country;
    var $trackers = context.$trackers,
      $sentry = context.$sentry;
    var recommendationWidgetId = ref('');
    var recommendationId = ref('');
    var recommendedProducts = ref([]);
    var canShowRightButton = ref(false);
    var productsRef = ref(null);
    var freeAboveRate = ref(null);
    var giftCartDiscountRate = ref(null);
    var upsellProducts = useUpsellProducts();
    var _useGetTranslations = useGetTranslations(),
      translate = _useGetTranslations.translate;
    var _useCartPreview = useCartPreview(),
      discountedSubtotal = _useCartPreview.discountedSubtotal;
    var centDiscountedSubtotal = computed(function () {
      return discountedSubtotal.value * 100;
    });
    var progressBarLimit = computed(function () {
      if (!freeAboveRate.value && !giftCartDiscountRate.value) return [];else if (freeAboveRate.value && !giftCartDiscountRate.value) return [freeAboveRate.value];else if (!freeAboveRate.value && giftCartDiscountRate.value) return [giftCartDiscountRate.value];else {
        return freeAboveRate.value.centAmount < giftCartDiscountRate.value.centAmount ? [freeAboveRate.value, giftCartDiscountRate.value] : [giftCartDiscountRate.value, freeAboveRate.value];
      }
    });
    var centAmounts = computed(function () {
      return progressBarLimit.value.map(function (rate) {
        return rate.centAmount;
      }).sort(function (a, b) {
        return a - b;
      });
    });
    var upsellTitle = computed(function () {
      if (isProgressBarShown.value) {
        var _progressBarLimit$val, _progressBarLimit$val2;
        var index = centAmounts.value.findIndex(function (centAmount) {
          return centAmount > centDiscountedSubtotal.value;
        });
        if (index === -1) return translate('upsell.title');
        if (((_progressBarLimit$val = progressBarLimit.value[index]) === null || _progressBarLimit$val === void 0 ? void 0 : _progressBarLimit$val.key) === 'freeAboveRate') {
          var region = translate("upsell.regions.".concat(freeAboveRate.value.country) && isProgressBarShown.value ? '*' : '');
          return "".concat(translate('upsell.buyForFreeShipping')).concat(region);
        } else if (((_progressBarLimit$val2 = progressBarLimit.value[index]) === null || _progressBarLimit$val2 === void 0 ? void 0 : _progressBarLimit$val2.key) === 'gift_1000') {
          return translate('upsell.titleGift');
        }
      }
      return translate('upsell.title');
    });
    var isMaxThresholdCrossed = computed(function () {
      return centAmounts.value[centAmounts.value.length - 1] <= centDiscountedSubtotal.value;
    });
    var isProgressBarShown = computed(function () {
      var _freeAboveRate$value;
      return countItemsWithoutGift.value > 0 && ((_freeAboveRate$value = freeAboveRate.value) === null || _freeAboveRate$value === void 0 ? void 0 : _freeAboveRate$value.centAmount) > 0 && !isMaxThresholdCrossed.value && centDiscountedSubtotal.value > 0;
    });
    var initShippingMethods = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var _cart$value;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              if (!((_cart$value = cart.value) !== null && _cart$value !== void 0 && _cart$value.id)) {
                _context.next = 6;
                break;
              }
              if (cart.value.shippingAddress) {
                _context.next = 4;
                break;
              }
              _context.next = 4;
              return updateShippingAddress({
                country: country
              });
            case 4:
              _context.next = 6;
              return loadShippingMethods(cart.value.id);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function initShippingMethods() {
        return _ref.apply(this, arguments);
      };
    }();
    var submitAddressAndFetchMethods = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _yield$getShippingFre, shippingFreeAboveRate, shippingFreeAboveRateForGift;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _context2.next = 3;
              return initShippingMethods();
            case 3:
              _context2.next = 5;
              return getShippingFreeAboveRate();
            case 5:
              _yield$getShippingFre = _context2.sent;
              shippingFreeAboveRate = _yield$getShippingFre.shippingFreeAboveRate;
              shippingFreeAboveRateForGift = _yield$getShippingFre.shippingFreeAboveRateForGift;
              giftCartDiscountRate.value = shippingFreeAboveRateForGift;
              freeAboveRate.value = shippingFreeAboveRate;
              _context2.next = 17;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              console.error('Failed to fetch standard shipping method or its free above rate - ', _context2.t0);
              $sentry === null || $sentry === void 0 ? void 0 : $sentry.setContext('error', _context2.t0);
              $sentry === null || $sentry === void 0 ? void 0 : $sentry.captureException(_context2.t0);
            case 17:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 12]]);
      }));
      return function submitAddressAndFetchMethods() {
        return _ref2.apply(this, arguments);
      };
    }();
    onMounted(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      var _cart$value2, _recommendedProducts$, itemsSkus;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            _context3.prev = 0;
            itemsSkus = (_cart$value2 = cart.value) === null || _cart$value2 === void 0 ? void 0 : _cart$value2.lineItems.map(function (item) {
              var _item$variant;
              return item === null || item === void 0 ? void 0 : (_item$variant = item.variant) === null || _item$variant === void 0 ? void 0 : _item$variant.sku;
            });
            _context3.next = 4;
            return upsellProducts.get(itemsSkus);
          case 4:
            recommendationId.value = upsellProducts.result.value.id;
            recommendationWidgetId.value = upsellProducts.getWidgetId();
            recommendedProducts.value = upsellProducts.result.value.recommendations;
            canShowRightButton.value = ((_recommendedProducts$ = recommendedProducts.value) === null || _recommendedProducts$ === void 0 ? void 0 : _recommendedProducts$.length) > 1;
            _context3.next = 13;
            break;
          case 10:
            _context3.prev = 10;
            _context3.t0 = _context3["catch"](0);
            console.error('Failed to fetch upsell products recommendation - ', _context3.t0);
          case 13:
          case "end":
            return _context3.stop();
        }
      }, _callee3, null, [[0, 10]]);
    })));
    watch(cart, /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee4(newCart) {
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              if (!newCart) {
                _context4.next = 3;
                break;
              }
              _context4.next = 3;
              return submitAddressAndFetchMethods();
            case 3:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x) {
        return _ref4.apply(this, arguments);
      };
    }());
    watch(isCartSidebarOpen, function () {
      if (isCartSidebarOpen.value) {
        var _upsellProducts$resul, _upsellProducts$resul2;
        var attraqt_items = (_upsellProducts$resul = upsellProducts.result.value) === null || _upsellProducts$resul === void 0 ? void 0 : _upsellProducts$resul.recommendations.map(function (item, index) {
          var _item$product;
          return {
            product_sku: item.id || '',
            item_name: ((_item$product = item.product) === null || _item$product === void 0 ? void 0 : _item$product.name) || '',
            index: index + 1 || ''
          };
        });
        $trackers.gtm.pushEvent('upsell_view', {
          event: 'upsell_view',
          event_action: 'view',
          event_category: 'upsell',
          event_name: 'upsell_view',
          source_id: ((_upsellProducts$resul2 = upsellProducts.result.value) === null || _upsellProducts$resul2 === void 0 ? void 0 : _upsellProducts$resul2.id) || '',
          widget_id: upsellProducts.getWidgetId(),
          attraqt_items: attraqt_items
        });
      }
    });
    return {
      __sfc: true,
      updateShippingAddress: updateShippingAddress,
      isCustomerGroupWithoutVat: isCustomerGroupWithoutVat,
      isCartSidebarOpen: isCartSidebarOpen,
      loadShippingMethods: loadShippingMethods,
      getShippingFreeAboveRate: getShippingFreeAboveRate,
      cart: cart,
      countItemsWithoutGift: countItemsWithoutGift,
      context: context,
      country: country,
      $trackers: $trackers,
      $sentry: $sentry,
      recommendationWidgetId: recommendationWidgetId,
      recommendationId: recommendationId,
      recommendedProducts: recommendedProducts,
      canShowRightButton: canShowRightButton,
      productsRef: productsRef,
      freeAboveRate: freeAboveRate,
      giftCartDiscountRate: giftCartDiscountRate,
      upsellProducts: upsellProducts,
      translate: translate,
      discountedSubtotal: discountedSubtotal,
      centDiscountedSubtotal: centDiscountedSubtotal,
      progressBarLimit: progressBarLimit,
      centAmounts: centAmounts,
      upsellTitle: upsellTitle,
      isMaxThresholdCrossed: isMaxThresholdCrossed,
      isProgressBarShown: isProgressBarShown,
      initShippingMethods: initShippingMethods,
      submitAddressAndFetchMethods: submitAddressAndFetchMethods,
      UpSellProduct: UpSellProduct,
      ProgressBar: ProgressBar,
      NativeCarousel: NativeCarousel
    };
  }
});